module.exports = __webpack_public_path__ + "static/media/access-add.f7710631.svg";